export enum EContractorPaymentType {
  REGULAR = "regular",
  REIMBURSEMENT = "reimbursement",
  KIT = "kit",
  ALL = "all",
}
